module.exports = __webpack_public_path__ + "vue/img/inform.04b61392.svg";